import { cloneDeep, merge } from "lodash";
import editorProjectConfig from "@client/pages/editor/DataModel";

/**
 * 编辑器数据状态存储
 */
const state = {
  // 当前编辑器编辑工程项目数据
  projectData: {},
  // 当前正在编辑的页面uuid
  activePageUUID: "",
  // 画板中选中的元素uuid
  activeElementUUID: "",
  // 画板中选中的元素uuid - 多选
  activeElementUUIDMore: [],
  // 画板中选中的元素组uuid
  activeElementGroupUUID: "",
  // 画板中选中的动态面板uuid
  activeDynamicPanelUUID: "",
  // 画板中选中的动态面板state-uuid
  activeDynamicPanelStateUUID: "",
  // 历史操作数据用于undo redo
  historyCache: [],
  // redo undo 指针
  currentHistoryIndex: -1,
  activeAttrEditCollapse: ["1"],
};
const actions = {
  /**
   * 初始化编辑项目数据
   * @param state
   * @param data
   */
  setPrjectData({ commit, state, dispatch }, data) {
    let projectData = data;
    if (!projectData) {
      projectData = editorProjectConfig.getProjectConfig();
    }
    commit("setPrjectData", projectData);
    console.log(projectData, "setPrjectData");
    // 判断如果有页面择选中第一个没有则新建一个页面再选中第一个
    if (!state.projectData.pages || !state.projectData.pages.length) {
      dispatch("addPage");
    }
    dispatch("setActivePageUUID", state.projectData.pages[0].uuid);
  },
  /**
   * 设置当前选中页面uuid
   * @param state
   * @param data
   */
  setActivePageUUID({ commit }, uuid) {
    commit("setActivePageUUID", uuid);
    // 当前选中页面切换后清空元素选中的uuid
    commit("setActiveElementUUID", "");
    commit("addHistoryCache");
  },
  /**
   * 设置当前选中激活元素uuid
   * @param state
   * @param data
   */
  setActiveElementUUID({ commit, state }, uuid) {
    let uuidFilter = uuid;
    const activePage = getters.activePage(state);
    if(state.activeDynamicPanelUUID && !uuid){
      // 已开启动态面板，则默认选中该动态面板
      const dynamicPanel = activePage.elements.find((i) => i.uuid == state.activeDynamicPanelUUID);
      const dynamicPanelStateDefault = activePage.elements.find((i) => i.dynamicPanelUUID == state.activeDynamicPanelUUID);
      uuidFilter = dynamicPanel.uuid;
      dynamicPanelStateDefault && commit("setActiveDynamicPanelUUID", dynamicPanelStateDefault.dynamicPanelUUID);
      (!state.activeDynamicPanelStateUUID || 
        (state.activeDynamicPanelStateUUID && !dynamicPanel.states.map((i)=>i.uuid).includes(state.activeDynamicPanelStateUUID)) ) 
        && dynamicPanelStateDefault && commit("setActiveDynamicPanelStateUUID", dynamicPanelStateDefault.dynamicPanelStateUUID);
    }
    commit("setActiveElementUUID", uuidFilter);
    const activeElement = activePage.elements.find((i) => i.uuid == uuidFilter);
    if (activeElement && activeElement.dynamicPanelUUID) {
      commit("setActiveDynamicPanelUUID", activeElement.dynamicPanelUUID);
    }
    if (activeElement && activeElement.dynamicPanelStateUUID) {
      commit(
        "setActiveDynamicPanelStateUUID",
        activeElement.dynamicPanelStateUUID
      );
    }
  },
  /**
   * 选中了多个元素uuid
   * @param state
   * @param data
   */
  setActiveElementUUIDMore({ commit, state }, uuid) {
    if (uuid) {
      if (!state.activeElementUUIDMore.includes(uuid)) {
        commit("setActiveElementUUIDMore", [
          ...state.activeElementUUIDMore,
          uuid,
        ]);
      }
    } else {
      commit("setActiveElementUUIDMore", []);
    }
  },
  /**
   * 设置当前选中激活元素组uuid
   * @param state
   * @param data
   */
  setActiveElementGroupUUID({ commit, state }, uuid) {
    commit("setActiveElementGroupUUID", uuid);
    const activePage = getters.activePage(state);
    const activeElementGroup = activePage.elementGroups.find(
      (i) => i.uuid == uuid
    );
    console.log(activeElementGroup, "activeElementGroup");
    if (activeElementGroup && activeElementGroup.dynamicPanelUUID) {
      commit("setActiveDynamicPanelUUID", activeElementGroup.dynamicPanelUUID);
    }
    if (activeElementGroup && activeElementGroup.dynamicPanelStateUUID) {
      commit(
        "setActiveDynamicPanelStateUUID",
        activeElementGroup.dynamicPanelStateUUID
      );
    }
  },
  /**
   * 设置当前选中激活动态面板uuid
   * @param state
   * @param data
   */
  setActiveDynamicPanelUUID({ commit, dispatch }, uuid) {
    commit("setActiveDynamicPanelUUID", uuid);
    if (uuid) {
      const activeElement = getters.activeElement(state);
      if (activeElement.states.length < 1) {
        dispatch("addDynamicPanelState");
        commit("setActiveDynamicPanelStateUUID", activeElement.states[0].uuid);
      }
      if (!state.activeDynamicPanelStateUUID || !activeElement.states.map((i)=>i.uuid).includes(state.activeDynamicPanelStateUUID)) {
        commit("setActiveDynamicPanelStateUUID", activeElement.states[0].uuid);
      }
    }
    console.log(
      getters.activeDynamicPanelState(state),
      "activeDynamicPanelState"
    );
  },
  /**
   * 设置当前选中激活动态面板state-uuid
   * @param state
   * @param data
   */
  setActiveDynamicPanelStateUUID({ commit }, uuid) {
    commit("setActiveDynamicPanelStateUUID", uuid);
  },
  // ========================项目操作=========================
  /**
   *
   * @param commit
   * @param url
   */
  updateCoverImage({ commit }, url) {
    commit("updateCoverImage", url);
  },

  // =====================页面操作============================
  /**
   * 添加页面
   * @param commit
   */
  addPage({ commit }, uuid) {
    let data = editorProjectConfig.getPageConfig();
    let index = -1;
    if (uuid) {
      index = state.projectData.pages.findIndex((v) => {
        return v.uuid === uuid;
      });
    } else {
      index = state.projectData.pages.length - 1;
    }
    commit("insertPage", data, index);
    commit("addHistoryCache");
  },
  /**
   * 删除页
   * @param commit
   * @param dispatch
   * @param uuid
   */
  deletePage({ state, commit }, uuid) {
    if(state.projectData.pages.length <= 1){
      return; // 不可全部删除
    }
    let indexActive = 0;
    const indexCurrent = state.projectData.pages.findIndex((i)=>i.uuid == uuid);
    if(state.activePageUUID === uuid){
      if(indexCurrent == 0){
        indexActive = 1;
      }else{
        indexActive = indexCurrent - 1;
      }
      commit("setActivePageUUID", state.projectData.pages[indexActive].uuid);
    }
    commit("deletePage", indexCurrent);
    commit("addHistoryCache");
  },
  /**
   * 复制页面
   * @param commit
   * @param uuid
   */
  copyPage({ commit }, uuid) {
    let pageData = state.projectData.pages.find((v) => {
      return v.uuid === uuid;
    });
    let data = editorProjectConfig.copyPage(pageData);
    commit("insertPage", data);
    commit("addHistoryCache");
  },

  // =============================元素相关========================================

  /**
   * 添加元素
   * @param commit
   * @param data
   */
  addElement({ commit, dispatch, state }, elData) {
    const activePage = getters.activePage(state);
    let data = editorProjectConfig.getElementConfig(elData, {
      zIndex: activePage.elements.filter((i)=>!i.dynamicPanelUUID).length + 1,
    });
    if (state.activeDynamicPanelUUID) {
      // 判断是否开启动态面板 -- 打上动态面板标记
      data["dynamicPanelUUID"] = state.activeDynamicPanelUUID;
      data["dynamicPanelStateUUID"] = state.activeDynamicPanelStateUUID;
    }
    commit("addElement", data);
    commit("setActiveElementUUID", data.uuid);
    dispatch("resetElementZIndexAuto");
    commit("addHistoryCache");
    console.log(activePage.elements, "addElement-finished");
  },
  /**
   * 添加动态面板state
   * @param commit
   */
  addDynamicPanelState({ commit, state }) {
    const activeDynamicPanel = getters.activeDynamicPanel(state)
    const dynamicPanelStateDefault =
      editorProjectConfig.getDynamicPanelStateConfig(
        activeDynamicPanel.states.length + 1
      );
    commit("addDynamicPanelState", dynamicPanelStateDefault);
    commit("addHistoryCache");
  },
  /**
   * 删除动态面板state
   * @param commit
   */
  deleteDynamicPanelState({ commit, state, dispatch }, uuid) {
    const activeDynamicPanel = getters.activeDynamicPanel(state)
    if(activeDynamicPanel.states.length <= 1){
      return;
    }
    const elementIds = []
    getters.activePage(state).elements.filter((i)=>i.dynamicPanelStateUUID == uuid).map((i)=>elementIds.push(i.uuid))
    elementIds.map((i)=>dispatch("deleteElement", i))
    commit("deleteDynamicPanelState", uuid);
    if(state.activeDynamicPanelStateUUID == uuid){
      commit("setActiveDynamicPanelStateUUID", activeDynamicPanel.states[0].uuid);
    }
    commit("addHistoryCache");
  },
  /**
   * 添加元素群组
   * @param commit
   * @param data
   */
  addElementGroups({ commit, dispatch, state }) {
    let data = editorProjectConfig.getElementGroupsConfig(
      state.activeElementUUIDMore
    );
    if (state.activeDynamicPanelUUID) {
      // 判断是否开启动态面板 -- 打上动态面板标记
      data["dynamicPanelUUID"] = state.activeDynamicPanelUUID;
      data["dynamicPanelStateUUID"] = state.activeDynamicPanelStateUUID;
    }
    commit("addElementGroups", data);
    commit("setActiveElementGroupUUID", data.uuid);
    dispatch("resetElementZIndexAuto");
    commit("addHistoryCache");
  },
  /**
   * 删除元素群组
   * @param commit
   * @param data
   */
  deleteElementGroups({ commit, dispatch, state }) {
    if(!state.activeElementGroupUUID){
      return;
    }
    commit("deleteElementGroups", state.activeElementGroupUUID);
    commit("setActiveElementUUID", "");
    commit("setActiveElementUUIDMore", "");
    commit("setActiveElementGroupUUID", "");
    dispatch("resetElementZIndexAuto");
    commit("addHistoryCache");
  },
  deleteElement({ state, dispatch, commit }, uuid) {
    !uuid && getters.activeElement(state) && (uuid = getters.activeElement(state).uuid);
    if(!uuid) return;
    const page = getters.activePage(state);
    console.log(page, uuid, 'deleteElement')
    const data = page.elements.find((i) => i.uuid == uuid);
    if(data.isDynamicPanel){ // 判断动态面板
      page.elements.filter((i)=>i.dynamicPanelUUID == uuid).map((i)=>commit("deleteElement", i.uuid));
    }
    // 如果删除选中元素则取消元素选中
    if (uuid === state.activeElementUUID) {
      commit("setActiveElementUUID", "");
    }
    commit("deleteElement", uuid);
    dispatch("resetElementZIndexAuto");
    commit("addHistoryCache");
  },
  /**
   * 元素指令， 用于结束针对元素修改相关指令，再由此方法派发actions做具体修改
   * @param dispatch
   * @param type
   * @param data
   */
  elementCommand({ commit, dispatch, state }, { command, uuid }) {
    let elData = uuid
      ? getters.activePage(state).elements.find((i) => i.uuid == uuid)
      : getters.activeElement(state);
    switch (command) {
      case "copy":
        dispatch("copyElement", { elData });
        break;
      case "delete":
        dispatch("deleteElement", elData.uuid);
        break;
      case "fontA+":
        dispatch("resetElementCommonStyle", {
          fontSize: elData.commonStyle.fontSize + 1,
        });
        break;
      case "fontA-":
        dispatch("resetElementCommonStyle", {
          fontSize: elData.commonStyle.fontSize - 1,
        });
        break;
      case "fontB":
        dispatch("resetElementCommonStyle", {
          fontWeight:
            elData.commonStyle.fontWeight === "bold" ? "normal" : "bold",
        });
        break;
      case "layerUp":
        commit("resetElementZIndex", { uuid: elData.uuid, type: "layerUp" });
        commit("addHistoryCache");
        break;
      case "layerDown":
        commit("resetElementZIndex", { uuid: elData.uuid, type: "layerDown" });
        commit("addHistoryCache");
        break;
      case "layerTop":
        commit("resetElementZIndex", { uuid: elData.uuid, type: "layerTop" });
        commit("addHistoryCache");
        break;
      case "layerBottom":
        commit("resetElementZIndex", {
          uuid: elData.uuid,
          type: "layerBottom",
        });
        commit("addHistoryCache");
        break;
      case "deleteElementGroups":
        dispatch("deleteElementGroups");
        break;
      case "copyElementGroups":
        dispatch("copyElementGroups", {});
        break;
      default:
        break;
    }
  },
  resetElementZIndexAuto({ commit }){
    getters.activePage(state).elements[0] && getters.activePage(state).elements[0].uuid && commit("resetElementZIndex", { uuid: getters.activePage(state).elements[0].uuid, type: "reset" });
  },
  resetElementZIndex({ commit }, data) {
    commit("resetElementZIndex", data);
    commit("addHistoryCache");
  },
  resetAllElementZIndex({ commit }, data) {
    commit("resetAllElementZIndex", data);
    commit("addHistoryCache");
  },
  /**
   * 复制动态面板state
   * @param commit
   */
  copyDynamicPanelState({commit, dispatch, state}, uuid){
    const activePage = getters.activePage(state);
    const activeDynamicPanel = getters.activeDynamicPanel(state)
    const copyOriginDynamicPanelState = activeDynamicPanel.states.find((i)=>i.uuid == uuid)
    const data = editorProjectConfig.copyDynamicPanelState(copyOriginDynamicPanelState);
    commit("addDynamicPanelState", data);
    // 检测复制来源state有的元件、组合
    const elementsUUIDs = []
    const elements = activePage.elements.filter((i)=>i.dynamicPanelStateUUID == copyOriginDynamicPanelState.uuid && i.dynamicPanelUUID == activeDynamicPanel.uuid && elementsUUIDs.push(i.uuid))
    let elementGroupsInnerUUIDS = []
    const elementGroups = activePage.elementGroups.filter((i)=>i.dynamicPanelStateUUID == copyOriginDynamicPanelState.uuid && i.dynamicPanelUUID == activeDynamicPanel.uuid && elementGroupsInnerUUIDS.push(i.list))
    elementGroupsInnerUUIDS = elementGroupsInnerUUIDS.flat();
    const elementsUUIDsNeed = []
    elementsUUIDs.map((i)=>!elementGroupsInnerUUIDS.includes(i) && elementsUUIDsNeed.push(i))
    elementGroups.map((i)=>{
      dispatch("copyElementGroups", {
        elGroup: i,
        noHistory: true,
        dynamicPanelUUID: activeDynamicPanel.uuid,
        dynamicPanelStateUUID: data.uuid,
      });
    })
    elementsUUIDsNeed.map((i)=>{
      dispatch("copyElement", {
        elData: elements.find((m)=>m.uuid == i),
        noHistory: true,
        dynamicPanelUUID: activeDynamicPanel.uuid,
        dynamicPanelStateUUID: data.uuid,
      });
    })
    commit("setActiveElementUUID", activeDynamicPanel.uuid);
    commit("setActiveElementUUIDMore", '');
    commit("setActiveElementGroupUUID", '');
    commit("setActiveDynamicPanelStateUUID", data.uuid);
    commit("addHistoryCache");
  },
  /**
   * 复制独立元件
   */
  copyElement({ state, commit }, { elData, noHistory, dynamicPanelUUID, dynamicPanelStateUUID }) {
    let copyOriginData = elData ? elData : getters.activeElement(state);
    if(!copyOriginData || !copyOriginData.uuid){
      return;
    }
    let activePage = getters.activePage(state);
    const copy = (elData)=>{
      return editorProjectConfig.copyElement(elData, {
        zIndex: elData.commonStyle.zIndex + 1,
      });
    }
    let data = copy(copyOriginData);
    if(dynamicPanelUUID){
      data.dynamicPanelUUID = dynamicPanelUUID;
    }
    if(dynamicPanelStateUUID){
      data.dynamicPanelStateUUID = dynamicPanelStateUUID;
    }
    commit("addElement", data);
    // 判断复制来源是否有组合
    const elementGroupsIndex = activePage.elementGroups.findIndex((i)=>i.list.includes(copyOriginData.uuid));
    if(elementGroupsIndex > -1){
      activePage.elementGroups[elementGroupsIndex].list.push(data.uuid);
    }
    // 判断复制来源是否动态面板
    commit("setActiveElementUUID", data.uuid);
    if(data.isDynamicPanel){
      const elemIndex = activePage.elements.findIndex((i)=>i.uuid == data.uuid);
      let statesCheck = {}, statesNew = [];
      data.states.map((i)=>{
        statesCheck[i.uuid] = editorProjectConfig.createUUID()
        const item = i;
        item.uuid = statesCheck[i.uuid]
        statesNew.push(item);
      })
      activePage.elements[elemIndex].states = statesNew;
      activePage.elements.filter((i)=>i.dynamicPanelUUID == copyOriginData.uuid).map((i)=>{
        const copyElem = copy(i);
        copyElem.dynamicPanelUUID = data.uuid;
        copyElem.dynamicPanelStateUUID = statesCheck[i.dynamicPanelStateUUID];
        commit("addElement", copyElem);
      })
      // commit("setActiveDynamicPanelStateUUID", data.states[0].uuid);
      // dispatch('setActiveDynamicPanelUUID', data.uuid);
    }
    // 重置层级
    commit("resetElementZIndex", { uuid: data.uuid, type: "reset" });
    !noHistory && commit("addHistoryCache");
  },
  /**
   * 复制元件组合
   */
  copyElementGroups({ state, commit }, { elGroup, noHistory, dynamicPanelUUID, dynamicPanelStateUUID }) {
    let activePage = getters.activePage(state);
    let copyOriginGroup = elGroup ? elGroup : activePage.elementGroups.find((i)=>i.uuid == state.activeElementGroupUUID);
    if(!copyOriginGroup || !copyOriginGroup.uuid){
      return;
    }
    let group = editorProjectConfig.copyElementGroups(copyOriginGroup);
    const copy = (elData)=>{
      return editorProjectConfig.copyElement(elData, {
        zIndex: elData.commonStyle.zIndex + 1,
      });
    }
    const listNew = []
    group.list.map((i)=>{
      const data = copy(activePage.elements.find((m)=>m.uuid == i));
      if(dynamicPanelUUID){
        data.dynamicPanelUUID = dynamicPanelUUID;
      }
      if(dynamicPanelStateUUID){
        data.dynamicPanelStateUUID = dynamicPanelStateUUID;
      }
      commit("addElement", data);
      listNew.push(data.uuid);
      if(data.isDynamicPanel){ // 判断动态面板
        const elemIndex = activePage.elements.findIndex((i)=>i.uuid == data.uuid);
        let statesCheck = {}, statesNew = [];
        data.states.map((m)=>{
          statesCheck[m.uuid] = editorProjectConfig.createUUID()
          const item = m;
          item.uuid = statesCheck[m.uuid]
          statesNew.push(item);
        })
        activePage.elements[elemIndex].states = statesNew;
        activePage.elements.filter((u)=>u.dynamicPanelUUID == u.uuid).map((m)=>{
          const copyElem = copy(m);
          copyElem.dynamicPanelUUID = data.uuid;
          copyElem.dynamicPanelStateUUID = statesCheck[m.dynamicPanelStateUUID];
          commit("addElement", copyElem);
        })
      }
    })
    group.list = listNew;
    if(dynamicPanelUUID){
      group.dynamicPanelUUID = dynamicPanelUUID;
    }
    if(dynamicPanelStateUUID){
      group.dynamicPanelUUID = dynamicPanelStateUUID;
    }
    commit("addElementGroups", group);
    commit("setActiveElementUUID", '');
    commit("setActiveElementUUIDMore", listNew);
    commit("setActiveElementGroupUUID", group.uuid);
    commit("resetElementZIndex", { uuid: group.uuid, type: "reset" });
    !noHistory && commit("addHistoryCache");
  },
  resetElementCommonStyle({ commit }, style) {
    commit("resetElementCommonStyle", style);
    commit("addHistoryCache");
  },
  /**
   * 添加动画到元素上
   * @param commit
   * @param animationName
   */
  addElementAnimate({ commit }, animationName) {
    // 初始化数据
    let animateDefaultData =
      editorProjectConfig.getElementAnimateConfig(animationName);
    commit("addElementAnimate", animateDefaultData);
    commit("addHistoryCache");
  },
  /**
   * 删除动画
   * @param commit
   * @param index
   */
  deleteElementAnimate({ commit }, index) {
    commit("deleteElementAnimate", index);
    commit("addHistoryCache");
  },

  /**
   * 添加事件
   * @param commit
   * @param type
   */
  addElementEvent({ commit }, type) {
    // 初始化数据
    let eventDefaultData = {
      type: type,
      url: "", // 跳转链接
      elementUUIDs: [], // 响应元素组
      action: "", // 显示：show，隐藏：hide，跳转链接：link，等待：wait
      millisecond: 0, // 等待毫秒
      dynamicPanelUUID: '', // 动态面板UUID
      dynamicPanelStateUUID: '', // 切换的state-uuid/next/prev
      dynamicPanelLoop: 0, // 1：向后循环
      dynamicPanelAnimationIn: '', // 进入动画
      dynamicPanelAnimationInMillisecond: 0, // 进入动画毫秒
      dynamicPanelAnimationOut: '', // 退出动画
      dynamicPanelAnimationOutMillisecond: 0, // 退出动画毫秒
      setWidth: 0, // 设置尺寸-宽度
      setHeight: 0, // 设置尺寸-高度
      widthHeightLocked: 1, // 宽度-高度-锁住
      setZIndex: 0, // 置顶/置底
    };
    commit("addElementEvent", eventDefaultData);
    commit("addHistoryCache");
  },

  /**
   * 添加事件
   * @param commit
   * @param type
   */
  addPageEvent({ commit }, type) {
    // 初始化数据
    let eventDefaultData = {
      type: type,
      url: "", // 跳转链接
      elementUUIDs: [], // 响应元素组
      action: "", // 显示：show，隐藏：hide，跳转链接：link，等待：wait
      millisecond: 0, // 等待毫秒
    };
    commit("addPageEvent", eventDefaultData);
    commit("addHistoryCache");
  },

  /**
   * 添加动作-事件
   * @param commit
   * @param index
   * @param data
   */
  addElementEventAction({ commit }, { index, data }) {
    commit("addElementEventAction", { index, data });
    commit("addHistoryCache");
  },

  /**
   * 添加动作-事件
   * @param commit
   * @param index
   * @param data
   */
  addPageEventAction({ commit }, { index, data }) {
    commit("addPageEventAction", { index, data });
    commit("addHistoryCache");
  },

  /**
   * 添加动作-事件-元件组
   * @param commit
   * @param index
   * @param data
   */
  addElementEventActionElementUUIDs({ commit }, { index, data }) {
    commit("addElementEventActionElementUUIDs", { index, data });
    commit("addHistoryCache");
  },

  /**
   * 添加动作-事件-元件组
   * @param commit
   * @param index
   * @param data
   */
  addPageEventActionElementUUIDs({ commit }, { index, data }) {
    commit("addPageEventActionElementUUIDs", { index, data });
    commit("addHistoryCache");
  },

  /**
   * 删除事件
   * @param commit
   * @param index
   */
  deleteElementEvent({ commit }, index) {
    commit("deleteElementEvent", index);
    commit("addHistoryCache");
  },

  /**
   * 删除事件
   * @param commit
   * @param index
   */
  deletePageEvent({ commit }, index) {
    commit("deletePageEvent", index);
    commit("addHistoryCache");
  },

  // =====================历史纪录=======================
  /**
   * 记入历史纪录
   * @param commit
   * @param index 插入到index后
   */
  addHistoryCache({ commit }) {
    commit("addHistoryCache");
  },
  editorUndo({ commit, state }) {
    if (!getters.canUndo(state)) {
      return;
    }
    const prevState = state.historyCache[state.currentHistoryIndex - 1];
    commit("relapceEditorState", cloneDeep(prevState));
    commit("editorUndo");
  },
  editorRedo({ commit }) {
    if (!getters.canRedo(state)) {
      return;
    }
    const prevState = state.historyCache[state.currentHistoryIndex + 1];
    commit("relapceEditorState", cloneDeep(prevState));
    commit("editorRedo");
  },
};
const mutations = {
  setPrjectData(state, data) {
    state.projectData = data;
  },
  setActivePageUUID(state, data) {
    state.activePageUUID = data;
  },
  setActiveElementUUID(state, data) {
    state.activeElementUUID = data;
  },
  setActiveElementUUIDMore(state, data) {
    state.activeElementUUIDMore = data;
  },
  setActiveElementGroupUUID(state, data) {
    state.activeElementGroupUUID = data;
  },
  setActiveDynamicPanelUUID(state, data) {
    state.activeDynamicPanelUUID = data;
  },
  setActiveDynamicPanelStateUUID(state, data) {
    state.activeDynamicPanelStateUUID = data;
  },
  /**
   * 更新项目主图
   * @param commit
   * @param url
   */
  updateCoverImage(state, url) {
    state.projectData.coverImage = url;
  },
  /**
   * 新增页面
   */
  insertPage(state, data, index) {
    if (index) {
      state.projectData.pages.splice(index, 0, data);
    } else {
      state.projectData.pages.push(data);
    }
  },
  /**
   * 删除页面
   */
  deletePage(state, index) {
    state.projectData.pages.splice(index, 1);
  },

  // =============================元素相关========================================

  /**
   * 往画板添加元素
   * @param state
   * @param elData
   */
  addElement(state, elData) {
    let index = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    state.projectData.pages[index].elements.push(elData);
  },

  /**
   * 添加画板state
   * @param state
   */
  addDynamicPanelState(state, data) {
    const activeDynamicPanel = getters.activeDynamicPanel(state);
    activeDynamicPanel.states.push(data);
  },

  /**
   * 删除画板state
   * @param state
   * @param uuid
   */
  deleteDynamicPanelState(state, uuid){
    const activeDynamicPanel = getters.activeDynamicPanel(state);
    const activeDynamicPanelStateIndex = activeDynamicPanel.states.findIndex((i)=>i.uuid == uuid)
    activeDynamicPanel.states.splice(
      activeDynamicPanelStateIndex,
      1
    );
  },
  /**
   * 添加元素组
   * @param state
   * @param elData
   */
  addElementGroups(state, data) {
    let index = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    if (!state.projectData.pages[index].elementGroups) {
      state.projectData.pages[index].elementGroups = [];
    }
    let maxZIndex = 0;
    data.list.map((i) => {
      const elemZIndex = state.projectData.pages[index].elements.find(
        (m) => m.uuid == i
      ).commonStyle.zIndex;
      maxZIndex < elemZIndex && (maxZIndex = elemZIndex);
    });
    data.zIndex = maxZIndex;
    state.projectData.pages[index].elementGroups.push(data);
  },
  /**
   * 删除元素
   * @param state
   * @param uuid
   */
  deleteElement(state, uuid) {
    let activePage = getters.activePage(state);
    // 先查询组内是否有该元素，删除索引
    let elementIndexInGroup = -1,
      elementGroupsIndex = -1;
    if (activePage.elementGroups) {
      elementGroupsIndex = activePage.elementGroups.findIndex((i) =>
        i.list.find((m, n) => m == uuid && (elementIndexInGroup = n))
      );
    }
    if (elementGroupsIndex > -1) {
      activePage.elementGroups[elementGroupsIndex].list.splice(
        elementIndexInGroup,
        1
      );
    }
    let elementIndex = activePage.elements.findIndex((v) => {
      return v.uuid === uuid;
    });
    activePage.elements.splice(elementIndex, 1);
  },
  /**
   * 删除元素群组
   * @param state
   * @param uuid
   */
  deleteElementGroups(state, uuid) {
    let activePage = getters.activePage(state);
    let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
      return v.uuid === uuid;
    });
    activePage.elementGroups.splice(elementGroupIndex, 1);
  },
  /**
   * 重置元素样式，
   * @param commit
   * @param uuid
   * @param styleObject
   */
  resetElementCommonStyle(state, style) {
    let activeElement = getters.activeElement(state);
    activeElement.commonStyle = merge(activeElement.commonStyle, style);
  },

  /**
   * 添加动画到元素上
   * @param state
   * @param data
   */
  addElementAnimate(state, data) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将动画添加到组合上
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      if (!activePage.elementGroups[elementGroupIndex].animations) {
        activePage.elementGroups[elementGroupIndex].animations = [];
      }
      activePage.elementGroups[elementGroupIndex].animations.push(data);
    } else {
      activeElement.animations.push(data);
    }
  },
  /**
   * 删除动画到元素上
   * @param state
   * @param index
   */
  deleteElementAnimate(state, index) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将组合的动画删除
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      activePage.elementGroups[elementGroupIndex].animations.splice(index, 1);
    } else {
      activeElement.animations.splice(index, 1);
    }
  },
  /**
   * 添加动作
   * @param state
   * @param data
   */
  addElementEvent(state, data) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将动作添加到组合上
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      if (!activePage.elementGroups[elementGroupIndex].events) {
        activePage.elementGroups[elementGroupIndex].events = [];
      }
      activePage.elementGroups[elementGroupIndex].events.push(data);
    } else {
      activeElement.events.push(data);
    }
  },
  /**
   * 添加动作
   * @param state
   * @param data
   */
  addPageEvent(state, data) {
    getters.activePage(state).events.push(data);
  },
  /**
   * 添加动作-事件
   * @param state
   * @param data
   */
  addElementEventAction(state, { index, data }) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将动作-事件添加到组合上
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      activePage.elementGroups[elementGroupIndex].events[index].action = data;
    } else {
      activeElement.events[index].action = data;
    }
  },
  /**
   * 添加动作-事件
   * @param state
   * @param data
   */
  addPageEventAction(state, { index, data }) {
    getters.activePage(state).events[index].action = data;
  },
  /**
   * 添加动作-事件
   * @param state
   * @param data
   */
  addElementEventActionElementUUIDs(state, { index, data }) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将动作-事件添加到组合上
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      activePage.elementGroups[elementGroupIndex].events[index].elementUUIDs =
        data;
    } else {
      activeElement.events[index].elementUUIDs = data;
    }
  },
  /**
   * 添加动作-事件
   * @param state
   * @param data
   */
  addPageEventActionElementUUIDs(state, { index, data }) {
    getters.activePage(state).events[index].elementUUIDs = data;
  },
  /**
   * 删除事件
   * @param state
   * @param index
   */
  deleteElementEvent(state, index) {
    let activeElement = getters.activeElement(state);
    // 若当前选中元件为组合，则将组合的事件删除
    if (state.activeElementGroupUUID) {
      let activePage = getters.activePage(state);
      let elementGroupIndex = activePage.elementGroups.findIndex((v) => {
        return v.uuid === state.activeElementGroupUUID;
      });
      activePage.elementGroups[elementGroupIndex].events.splice(index, 1);
    } else {
      activeElement.events.splice(index, 1);
    }
  },
  /**
   * 删除事件
   * @param state
   * @param index
   */
  deletePageEvent(state, index) {
    getters.activePage(state).events.splice(index, 1);
  },
  /**
   * 匹配并改变元素所在位置
   * @param state
   * @param uuid
   * @param type layerUp上一层，layerDown下一层，layerTop置顶， layerBottom置底
   */
  resetElementZIndex(state, { uuid, type }) {
    uuid = uuid || state.activeElementUUID;
    const elementManage = cloneDeep(getters.elementManage(state));
    console.log(elementManage, "resetElementZIndex");
    const switchType = (type, index, length) => {
      let indexNext = index;
      switch (type) {
        case "layerUp": // 上移
          indexNext = indexNext < 1 ? 0 : indexNext - 1;
          break;
        case "layerDown": // 下移
          indexNext = indexNext < length - 1 ? indexNext + 1 : length - 1;
          break;
        case "layerTop": // 置顶
          indexNext = 0;
          break;
        case "layerBottom": // 置底
          indexNext = length - 1;
          break;
        case "set0":
          indexNext = length - 1;
          break;
        case "reset":
          indexNext = index; // 重置
          break;
      }
      return indexNext;
    };
    const spliceAction = (list, item, index)=>{
      const elementIndexAction = switchType(type, index, list.length );
      list.splice(index, 1);
      list.splice(elementIndexAction, 0, item);
    }
    let resultFunc = ()=>{}
    let stopRecursion = false;
    const matchUUID = (arr, targetUUID)=>{
      const search = (obj, parent, index)=>{
        if (obj.uuid === targetUUID) {
          resultFunc = spliceAction(parent, parent[index], index);
          stopRecursion = true;
          return;
        } else if (obj.list && obj.list.length > 0 && !stopRecursion) {
          for (let i = 0; i < obj.list.length; i++) {
            search(obj.list[i], obj.list, i);
            if (stopRecursion) {
              break;
            }
          }
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (stopRecursion) { // 检查stopRecursion的值，如果为true则终止循环
          break;
        }
        search(arr[i], arr, i);
      }
    }
    matchUUID(elementManage, uuid);
    resultFunc && resultFunc();
    mutations.resetAllElementZIndex(state, { array: elementManage });
  },
  /**
   * 调整所有元素zIndex
   * @param state
   * @param array 已排好下标位置（降序）的新元素组（包含元素组合、元素）
   */
  resetAllElementZIndex(state, { array }) {
    const activePage = getters.activePage(state);
    let totalLength = activePage.elements.filter( // 获取所有非控制面板内部元件的独立元件总数
      (i) => !i.dynamicPanelUUID
    ).length;
    const dynamicPanelInnerZIndexReset = (i)=>{
      i.list && i.list.map((m) => {
        const dynamicPanelStateElements = activePage.elements.filter(
          (p) =>
            p.dynamicPanelUUID == i.uuid && p.dynamicPanelStateUUID == m.uuid
        );
        let dynamicPanelStateLength = dynamicPanelStateElements.length;
        m.list && m.list.map((p) => {
          if (p.isGroup) {
            const elementGroupIndex = activePage.elementGroups.findIndex(
              (z) => z.uuid == p.uuid
            );
            if (elementGroupIndex > -1) {
              activePage.elementGroups[elementGroupIndex].zIndex =
                dynamicPanelStateLength;
              p.list.map((z) => {
                const elementIndexInner = activePage.elements.findIndex(
                  (o) => o.uuid == z.uuid
                );
                activePage.elements[elementIndexInner].commonStyle.zIndex =
                  dynamicPanelStateLength--;
                if(z.isDynamicPanel){
                  dynamicPanelInnerZIndexReset(p);
                }
              });
            }
          } else {
            const elementIndexInner = activePage.elements.findIndex(
              (z) => z.uuid == p.uuid
            );
            activePage.elements[elementIndexInner].commonStyle.zIndex =
              dynamicPanelStateLength--;
            if(p.isDynamicPanel){
              dynamicPanelInnerZIndexReset(p);
            }
          }
        });
      })
    }
    array.map((i) => {
      const elementIndex = activePage.elements.findIndex(
        (m) => m.uuid == i.uuid
      );
      if (elementIndex > -1) {
        // 独立元件-包括独立动态面板
        activePage.elements[elementIndex].commonStyle.zIndex = totalLength--;
      }
      if (i.isDynamicPanel) {
        // 独立动态面板，则内部层级自控
        dynamicPanelInnerZIndexReset(i);
      } else {
        // 非独立动态面板，则外部层级共用
        const elementGroupIndex = activePage.elementGroups.findIndex(
          (m) => m.uuid == i.uuid
        );
        if (elementGroupIndex > -1) {
          // 组合
          activePage.elementGroups[elementGroupIndex].zIndex = totalLength;
          i.list.map((u) => {
            if (u.isDynamicPanel) {
              // 组合内动态面板
              // 动态面板，内部层级自控
              dynamicPanelInnerZIndexReset(u);
            } else {
              // 组合内独立元件
              const elementIndexInner = activePage.elements.findIndex(
                (p) => p.uuid == u.uuid
              );
              activePage.elements[elementIndexInner].commonStyle.zIndex =
                totalLength--;
            }
          });
        }
      }
    });
  },
  // ================================历史纪录========================================
  /**
   * 新增一条历史纪录
   * @param state
   */
  addHistoryCache(state) {
    if (state.currentHistoryIndex + 1 < state.historyCache.length) {
      state.historyCache.splice(state.currentHistoryIndex + 1);
    }
    state.historyCache.push({
      projectData: cloneDeep(state.projectData),
      activePageUUID: state.activePageUUID,
      activeElementUUID: state.activeElementUUID,
      activeElementUUIDMore: state.activeElementUUIDMore,
      activeElementGroupUUID: state.activeElementGroupUUID,
      activeDynamicPanelUUID: state.activeDynamicPanelUUID,
      activeDynamicPanelStateUUID: state.activeDynamicPanelStateUUID,
    });
    // 限制undo 纪录步数，最多支持100步操作undo
    state.historyCache.splice(100);
    state.currentHistoryIndex++;
  },
  /**
   *
   * @param state
   */
  editorUndo(state) {
    state.currentHistoryIndex--;
  },
  /**
   *
   * @param state
   */
  editorRedo(state) {
    state.currentHistoryIndex++;
  },
  /**
   * 更新编辑器项目数据，从history中拿数据替换
   * @param state
   * @param data
   */
  relapceEditorState(state, data) {
    state.projectData = cloneDeep(data.projectData);
    state.activePageUUID = data.activePageUUID;
    state.activeElementUUID = data.activeElementUUID;
  },
  /**
   * 设置编辑属性折叠面板展开收起状态
   * @param state
   * @param data
   */
  updateActiveAttrEditCollapse(state, data) {
    state.activeAttrEditCollapse = [...data];
  },
};
const getters = {
  projectData(state) {
    return state.projectData;
  },
  /**
   * 当前选中的页面index
   * @param state
   * @returns {*}
   */
  currentPageIndex(state) {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return -1;
    }
    return state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
  },
  /**
   * 当前选中的页面index
   * @param state
   * @returns {*}
   */
  activeElementIndex(state) {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return -1;
    }
    let currentPageIndex = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    if (currentPageIndex === -1) {
      return -1;
    }
    return state.projectData.pages[currentPageIndex].elements.findIndex((v) => {
      return v.uuid === state.activeElementUUID;
    });
  },
  /**
   * 当前选中的页面
   */
  activePage() {
    // 如果不存在页面返回-1
    if (!state.projectData.pages || !state.activePageUUID) {
      return { commonStyle: {}, config: {} };
    }
    return state.projectData.pages.find((v) => {
      return v.uuid === state.activePageUUID;
    });
  },
  /**
   * 当前选中元素
   */
  activeElement() {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return { commonStyle: {}, propsValue: {} };
    }
    let currentPageIndex = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    if (currentPageIndex === -1) {
      return { commonStyle: {}, propsValue: {} };
    }
    return state.projectData.pages[currentPageIndex].elements.find((v) => {
      return v.uuid === state.activeElementUUID;
    });
  },
  /**
   * 当前选中的动态面板
   */
  activeDynamicPanel() {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return { commonStyle: {}, propsValue: {} };
    }
    const currentPageIndex = state.projectData.pages.findIndex(
      (v) => v.uuid === state.activePageUUID
    );
    if (currentPageIndex === -1) {
      return { commonStyle: {}, propsValue: {} };
    }
    return state.projectData.pages[currentPageIndex].elements.find(
      (v) => v.uuid === state.activeDynamicPanelUUID
    );
  },
  /**
   * 当前选中的动态面板的state
   */
  activeDynamicPanelState() {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return { commonStyle: {}, propsValue: {} };
    }
    const currentPageIndex = state.projectData.pages.findIndex(
      (v) => v.uuid === state.activePageUUID
    );
    if (currentPageIndex === -1) {
      return { commonStyle: {}, propsValue: {} };
    }
    const currentElementIndex = state.projectData.pages[
      currentPageIndex
    ].elements.findIndex((v) => v.uuid === state.activeDynamicPanelUUID);
    if (currentElementIndex === -1) {
      return { commonStyle: {}, propsValue: {} };
    }
    return state.projectData.pages[currentPageIndex].elements[
      currentElementIndex
    ].states.find((v) => v.uuid === state.activeDynamicPanelStateUUID);
  },
  /**
   * 当前选中元素组合
   */
  activeElementGroup() {
    // 如果不存在页面返回-1
    if (!state.projectData.pages) {
      return { commonStyle: {}, propsValue: {} };
    }
    let currentPageIndex = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    if (currentPageIndex === -1) {
      return { commonStyle: {}, propsValue: {} };
    }
    return state.projectData.pages[currentPageIndex].elementGroups.find((v) => {
      return v.uuid === state.activeElementGroupUUID;
    });
  },
  /**
   * 获取元件管理（包含元件组、元件，及层级排序，降序）
   */
  elementManageWithElType() {
    return funcs.elementManage(state, 1);
  },
  elementManage() {
    return funcs.elementManage(state);
  },
  canUndo(state) {
    return state.currentHistoryIndex > 0;
  },
  canRedo(state) {
    return state.historyCache.length > state.currentHistoryIndex + 1;
  },
};

const funcs = {
  elementManage: (state, elType) => {
    const fieldNames = {
      list: "list",
      name: "name",
      uuid: "uuid",
    };
    if (elType) {
      fieldNames.list = "children";
      fieldNames.name = "label";
      fieldNames.uuid = "value";
    }
    if (!state.projectData.pages) {
      return [];
    }
    const currentPageIndex = state.projectData.pages.findIndex((v) => {
      return v.uuid === state.activePageUUID;
    });
    if (currentPageIndex === -1) {
      return [];
    }
    const alreadyGroups = [];
    state.projectData.pages[currentPageIndex].elementGroups &&
      state.projectData.pages[currentPageIndex].elementGroups
        .filter((i) => !i.dynamicPanelUUID)
        .map((i) => i.list.map((m) => alreadyGroups.push(m)));
    return [
      ...(state.projectData.pages[currentPageIndex].elementGroups
        ? state.projectData.pages[currentPageIndex].elementGroups
            .filter((i) => !i.dynamicPanelUUID)
            .map((i) => {
              const result = {
                ...i,
                label: i.groupName,
                uuid: i.uuid,
                isGroup: 1,
              };
              result[fieldNames.name] = i.groupName;
              result[fieldNames.uuid] = i.uuid;
              const list = i.list
                .filter((m) =>
                  state.projectData.pages[currentPageIndex].elements.find(
                    (p) => p.uuid == m
                  )
                )
                .map((m) => {
                  const elem = state.projectData.pages[
                    currentPageIndex
                  ].elements.find((p) => p.uuid == m);
                  const elemResult = {
                    ...elem,
                    label: elem.elNameShow,
                    uuid: m,
                    isGroup: 0,
                    zIndex: elem.commonStyle.zIndex,
                  };
                  elemResult[fieldNames.name] = elem.elNameShow;
                  elemResult[fieldNames.uuid] = elem.uuid;
                  if (elem.isDynamicPanel) {
                    const already = [];
                    const group = state.projectData.pages[
                      currentPageIndex
                    ].elementGroups.filter(
                      (w) => w.dynamicPanelUUID == elem.uuid
                    );
                    elemResult[fieldNames.list] = getDynamicPanelStateList({
                      state,
                      currentPageIndex,
                      fieldNames,
                      p: elem,
                      group,
                      already,
                    });
                  }
                  return elemResult;
                })
                .sort((a, b) => b.commonStyle.zIndex - a.commonStyle.zIndex);
              if (list) {
                result[fieldNames.list] = list;
              }
              return result;
            })
        : []),
      ...state.projectData.pages[currentPageIndex].elements
        .filter((p) => !alreadyGroups.includes(p.uuid) && !p.dynamicPanelUUID)
        .map((p) => {
          const result = {
            ...p,
            label: p.elNameShow,
            uuid: p.uuid,
            zIndex: p.commonStyle.zIndex,
            isGroup: 0,
          };
          result[fieldNames.name] = p.elNameShow;
          result[fieldNames.uuid] = p.uuid;
          if (p.isDynamicPanel) {
            const already = [];
            const group = state.projectData.pages[
              currentPageIndex
            ].elementGroups.filter((w) => w.dynamicPanelUUID == p.uuid);
            result[fieldNames.list] = getDynamicPanelStateList({
              state,
              currentPageIndex,
              fieldNames,
              p,
              group,
              already,
            });
          }
          return result;
        }),
    ].sort((a, b) => b.zIndex - a.zIndex);
  },
};
const getDynamicPanelStateList = ({
  state,
  currentPageIndex,
  fieldNames,
  p,
  group,
  already,
}) => {
  return p.states.map((t) => {
    const dynamicPanelResult = {
      label: t.name,
      uuid: t.uuid,
      isState: 1,
    };
    dynamicPanelResult[fieldNames.name] = t.name;
    dynamicPanelResult[fieldNames.uuid] = t.uuid;
    dynamicPanelResult[fieldNames.list] = [
      ...(group
        ? group
            .filter((e) => e.dynamicPanelUUID == p.uuid && e.dynamicPanelStateUUID == t.uuid)
            .map((i) => {
              i.list.map((m) => already.push(m));
              const result = {
                ...i,
                label: i.groupName,
                uuid: i.uuid,
                isGroup: 1,
              };
              result[fieldNames.name] = i.groupName;
              result[fieldNames.uuid] = i.uuid;
              const list = i.list
                .filter((m) =>
                  state.projectData.pages[currentPageIndex].elements.find(
                    (e) => e.uuid == m
                  )
                )
                .map((m) => {
                  const elem = state.projectData.pages[
                    currentPageIndex
                  ].elements.find((e) => e.uuid == m);
                  const elemResult = {
                    ...elem,
                    label: elem.elNameShow,
                    uuid: m,
                    isGroup: 0,
                    zIndex: elem.commonStyle.zIndex,
                  };
                  elemResult[fieldNames.name] = elem.elNameShow;
                  elemResult[fieldNames.uuid] = elem.uuid;
                  if (elem.isDynamicPanel) {
                    const already = [];
                    const group = state.projectData.pages[
                      currentPageIndex
                    ].elementGroups.filter(
                      (w) => w.dynamicPanelUUID == elem.uuid
                    );
                    elemResult[fieldNames.list] = getDynamicPanelStateList({
                      state,
                      currentPageIndex,
                      fieldNames,
                      p: elem,
                      group,
                      already,
                    });
                  }
                  return elemResult;
                })
                .sort((a, b) => b.commonStyle.zIndex - a.commonStyle.zIndex);
              if (list) {
                result[fieldNames.list] = list;
              }
              return result;
            })
        : []),
      ...state.projectData.pages[currentPageIndex].elements
        .filter(
          (u) =>
            !already.includes(u.uuid) &&
            u.dynamicPanelUUID == p.uuid &&
            u.dynamicPanelStateUUID == t.uuid
        )
        .map((u) => {
          const elemResult = {
            ...u,
            label: u.elNameShow,
            uuid: u.uuid,
            isGroup: 0,
            zIndex: u.commonStyle.zIndex,
          };
          elemResult[fieldNames.name] = u.elNameShow;
          elemResult[fieldNames.uuid] = u.uuid;
          if (u.isDynamicPanel) {
            const already = [];
            const group = state.projectData.pages[
              currentPageIndex
            ].elementGroups.filter((w) => w.dynamicPanelUUID == u.uuid);
            elemResult[fieldNames.list] = getDynamicPanelStateList({
              state,
              currentPageIndex,
              fieldNames,
              p: u,
              group,
              already,
            });
          }
          return elemResult;
        }),
    ].sort((a, b) => b.zIndex - a.zIndex);
    return dynamicPanelResult;
  });
};

export default {
  state,
  getters,
  actions,
  mutations,
};
